export interface ProductSampleSpec {
  id: string;
  productId: string;
  sizeId: string;
  sizeKey: string;
  sizeDescription: string;
  labelId: string;
  labelKey: string;
  labelDescription: string;
}
